import { Button, ConfigProvider } from 'antd';
import React from 'react';

import styles from './TranslationHint.less';

interface TranslationHintProps {
  /** The sentence — or, in edit mode, the inline inputs that replace it. */
  children: React.ReactNode;
  /** Opens the wording editor; omitted, the strip is read-only. */
  actionLabel?: React.ReactNode;
  onAction?: () => void;
}

/**
 * The strip under a translated field: one sentence about the wording, plus the
 * action that edits it.
 *
 * The single place a field says something about its translation. A missing wording
 * used to be told twice in two visual languages — this strip under a mixed value, and
 * the bound field's own box turning amber with the message inside it — so the same
 * gap looked like two different problems. The field now always shows *where its words
 * come from*, and anything to say about them is said here.
 *
 * `componentDisabled={false}` on purpose: hosts render these fields inside a
 * `<Form disabled>` when the template may not be edited, and the wording is the
 * partner's, shared with every email that uses the key — filling one in is not an
 * edit of this template.
 */
const TranslationHint: React.FC<TranslationHintProps> = ({
  children,
  actionLabel,
  onAction,
}) => (
  <ConfigProvider componentDisabled={false}>
    <span className={styles.hint}>
      {children}
      {actionLabel !== undefined && (
        <Button
          className={styles.action}
          type="link"
          size="small"
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </span>
  </ConfigProvider>
);

export default React.memo(TranslationHint);
